import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-3" };
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "col-3" }, null, -1);
const _hoisted_6 = { class: "col-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.content, (tContent) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                    key: tContent.member
                }, [
                    (_ctx.$forms.isVisible(tContent, _ctx.$forms.getDataForEval(_ctx.schema, _ctx.data, _ctx.page)))
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentElementName(tContent.elementType)), {
                            key: 0,
                            schema: _ctx.schema,
                            content: tContent,
                            data: _ctx.data,
                            onCommand: _ctx.onCommand
                        }, null, 8, ["schema", "content", "data", "onCommand"]))
                        : _createCommentVNode("", true)
                ], 64));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                    href: '/frontend/v1/forms/processes/' + _ctx.process.processID + '/print',
                    target: "_blank",
                    class: "btn btn-outline-secondary"
                }, "Drucken", 8, _hoisted_4)
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_g_button, {
                    text: "Zurück zur Übersicht",
                    onClick: _ctx.gotoHome
                }, null, 8, ["onClick"])
            ])
        ])
    ], 64));
}
